<template>
  <button class="label" :class="classType"><slot></slot></button>
</template>

<script>
export default {
  props: {
    type: {
      type: Number,
      default: 0
    }
  },
  computed: {
    classType () {
      switch (this.type) {
        case 1:
          return 'even'
        case 0:
        default:
          return 'odd'
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
@import "index.css";
.label {
  outline: 0;
  @media (--mediaPc) {
    padding: 0 8px;
  }
  @media (--mediaMobile) {
    padding: 0 calc(8px / var(--scaleMobile));
  }
  &.odd {
    color: var(--labelColorOddText);
    background-color: var(--labelColorOdd);
    border: 1px solid rgba(227,232,245,1); /* #E3E8F5 100% */
  }
  &.even {
    color: var(--labelColorEvenText);
    background-color: var(--labelColorEven);
    border: 1px solid rgba(240,230,224,1); /* #F0E6E0 100% */
  }
}
</style>



// WEBPACK FOOTER //
// src/components/label/Label.vue